import { ISportInput, person } from './types';

interface IValueForm {
  selectedDay: string[];
  sport: string;
  time: string;
  nAdults: number;
  nChildren: number;
  adults: person[];
  children: person[];
  special: string;
}

export const initValueForm: IValueForm = {
  selectedDay: [],
  sport: '',
  time: '',
  nAdults: 0,
  nChildren: 0,
  adults: [],
  children: [],
  special: '',
};

export const CoachingFormInputs: ISportInput[] = [
  {
    name: 'sport',
    title: 'Select sport',
    label: 'Select Sport',
    items: [
      {
        label: 'Aerobics',
        value: 'Aerobics',
      },
      {
        label: 'Badminton (Sports Hall)',
        value: 'Badminton',
      },
      {
        label: 'Basketball (Sports Hall)',
        value: 'Basketball',
      },
      {
        label: 'Cricket',
        value: 'Cricket',
      },
      {
        label: 'Football',
        value: 'Football',
      },
      {
        label: 'Squash',
        value: 'Squash',
      },
      {
        label: 'Table Tennis',
        value: 'Table Tennis',
      },
      {
        label: 'Tennis',
        value: 'Tennis',
      },
      {
        label: 'Ten Pin Bowling',
        value: 'Ten Pin Bowling',
      },
      {
        label: 'Gym Trainers',
        value: 'Gym Trainers',
      },
    ],
    type: 'select',
  },
  {
    name: 'time',
    title: 'Select Preferred Time',
    label: 'Preferred Time',
    type: 'select',
    items: [
      {
        label: 'Morning',
        value: 'Morning',
      },
      {
        label: 'Afternoon',
        value: 'Afternoon',
      },
      {
        label: 'Evening',
        value: 'Evening',
      },
    ],
  },
];
